export const INSTANCE_STATUS = {
  OFF: 'OFF',
  NOT_CONFIGURED: 'NOT_CONFIGURED',
  CONFIGURATION_UPDATE: 'CONFIGURATION_UPDATE',
  OK: 'OK',
  UPDATE_FAILED: 'UPDATE_FAILED'
}
